import { ExternalReference } from 'graphql-query-contracts';
import { UpdateUnitProps } from '../types';

const isExternalReference = (ref: any): ref is ExternalReference =>
  ref != null &&
  ref.source &&
  ref.source.sourceType &&
  ref.source.sourceEntityId;

/**
 * This function is used because we currently only support one external reference per unit.
 * When the user edits the first reference, we need to replace it with the new one.
 * When the user clears the first reference, we need to remove it.
 * When the user adds a new reference, we need to add it.
 *
 * It should not result in updating references that were not shown to the user
 */
export const getUpdatedExternalReferences = (
  props: UpdateUnitProps
): ExternalReference[] => {
  const existingReferences = props.existingExternalReferences ?? [];
  let newExternalReferences: ExternalReference[] = [];

  if (props.unit.externalIdSource && props.unit.externalUnitId) {
    const editedReference: ExternalReference = {
      id: '',
      direct: true,
      source: {
        sourceType: props.unit.externalIdSource.value,
        sourceEntityId: props.unit.externalUnitId,
        sourceEntityType: props.unit.externalSourceEntityType,
      },
      relationshipSource: undefined,
    };

    const validReferences = existingReferences.filter(isExternalReference);

    if (validReferences.length > 0) {
      newExternalReferences = validReferences.map((ref, index) => {
        if (index === 0) {
          return editedReference;
        }

        return ref;
      });
    } else {
      newExternalReferences = [editedReference];
    }
  } else {
    newExternalReferences = existingReferences
      .filter(isExternalReference)
      .slice(1);
  }

  return newExternalReferences;
};
